import type { ReactNode } from 'react'
import { cx } from '../cx'
import styles from './Banner.module.css'

/**
 * Spec §4 "Toast / compel banner".
 *   compel — crimson bloom, carries Accept / Buy-off actions
 *   ember  — "you earned a Fate point"
 *   info / warn / error — the three `Notice.level` values every API envelope
 *     can carry (see the API's Contracts/Common/ApiContracts.cs). Stage 5 renders
 *     server notices through this same component.
 */
export type BannerTone = 'compel' | 'ember' | 'info' | 'warn' | 'error'

export interface BannerProps {
  tone: BannerTone
  children: ReactNode
  /** Rendered right-aligned — e.g. Accept / Buy-off on a compel. */
  actions?: ReactNode
  /** Announce assertively. Use for errors and compels the table is waiting on. */
  urgent?: boolean
  className?: string | undefined
}

export function Banner({ tone, children, actions, urgent = false, className }: BannerProps) {
  return (
    <div
      role={urgent ? 'alert' : 'status'}
      aria-live={urgent ? 'assertive' : 'polite'}
      className={cx(styles.banner, styles[tone], className)}
    >
      <div className={styles.body}>{children}</div>
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </div>
  )
}
